export default __webpack_public_path__ + "static/media/ultimate.e9ee26f6.png";